/**
 * Configuración de Cognito (AWS Amplify)
 * Reemplaza la configuración de Appwrite.
 * Inicializa Amplify una sola vez al importar este módulo.
 */

import { Amplify } from 'aws-amplify';
import { COGNITO_CONFIG } from '../constants/config';

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: COGNITO_CONFIG.USER_POOL_ID,
      userPoolClientId: COGNITO_CONFIG.CLIENT_ID,
    }
  }
});
